<router-outlet></router-outlet>

@if (debugPanelEnabled) {
  <ix-websocket-debug-panel></ix-websocket-debug-panel>
}
